@if ((useLazyLoad && !isLoaded) || pushs?.length > 0) {
  <div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
  <wc-wrapper
    [contentWrapper]="wrapper"
    [componentWidth]="showMoreDesktop ? componentWrapperWidthEnum.default : componentWrapperWidthEnum.fullWidth"
    [isPushCard]="true"
    [activeBrand]="activeBrand"
    >
    <!-- skeleton slider hack -->
    @if (!isReady) {
      <sd-push-slider sd-component-wrapper-component
        [titleLevel]="titleLevelHeading + 1"
        [size]="pushSize"
        [pushs]="pushsSkeleton"
        [brand]="brandCorner"
        [isLoading]="useLazyLoad && !isLoaded"
      />
    }
    <!-- end skeleton slider hack -->
    @if (isReady) {
      <sd-push-slider sd-component-wrapper-component
        #pushSliderComponent
        (clicked)="onClickLink($event)"
        (itemsRule)="onSlide($event)"
        [titleLevel]="titleLevelHeading + 1"
        [size]="pushSize"
        [pushs]="pushs"
        [context]="context"
        [twicPicsAutoSize]="!isFirst"
        [brand]="brandCorner"
        [isLoading]="useLazyLoad && !isLoaded"
      />
    }
  </wc-wrapper>
}
